export enum ExternalEnumerator{
    "Internal" = 0,
    "External" = 1
    }
      